<script lang="ts">
	import ArrowRightIcon from "@lucide/svelte/icons/arrow-right";
	import PhoneIcon from "@lucide/svelte/icons/phone";
	import { Button } from "#lib/web-ui/ui/button/index.js";
	import Section from "#lib/web-ui/primitives/section.svelte";
	import { getTemplateContext, cloudinaryUrl } from "../template-context.svelte";
	import { page } from "$app/state";

	let {
		title,
		description,
		buttonText = "Get My Cash Offer"
	}: {
		title?: string;
		description?: string;
		buttonText?: string;
	} = $props();

	const templateContext = getTemplateContext();
	const currentSearchParams = page.url.searchParams;
	const offerUrl = $derived(`/get-your-offer?${currentSearchParams.toString()}`);
</script>

<Section
	class="from-primary/60 via-primary/50 to-primary/80/40 relative overflow-hidden bg-gradient-to-br"
>
	<div class="bg-grid-white/[0.05] absolute inset-0 bg-[size:32px_32px]" aria-hidden="true"></div>
	<div
		class="bg-primary/80/20 absolute top-0 right-0 h-96 w-96 rounded-full blur-3xl"
		aria-hidden="true"
	></div>
	<div
		class="bg-primary/20 absolute bottom-0 left-0 h-96 w-96 rounded-full blur-3xl"
		aria-hidden="true"
	></div>

	<div class="relative flex max-w-4xl flex-col items-center gap-8">
		<div class="space-y-8 text-center">
			<h2 class="text-foreground text-5xl font-bold tracking-tight sm:text-6xl">
				{#if title}
					{title}
				{:else}
					Get My Free,
					<span
						class="from-primary/80 to-primary bg-gradient-to-r bg-clip-text text-transparent"
					>
						No-Obligation Quote
					</span>
				{/if}
			</h2>
			<p class="text-muted-foreground mx-auto max-w-2xl text-lg sm:text-xl">
				{#if description}
					{description}
				{:else}
					Call us today at <a
						href="tel:{templateContext.contact.phone}"
						class="text-foreground hover:text-primary/80 inline-flex items-center gap-1 font-semibold transition-colors"
					>
						<PhoneIcon class="text-muted-foreground" />
						{templateContext.contact.phone}
					</a> for an offer in as little as 24 hours. It's Quick and Easy!
				{/if}
			</p>
		</div>

		<div class="w-full max-w-2xl">
			<div
				class="shadow-primary/10 rounded-2xl bg-white p-8 shadow-2xl ring-1 ring-gray-900/5 backdrop-blur-sm sm:p-10"
			>
				<div class="space-y-6">
					<Button
						href={offerUrl}
						class="bg-primary text-primary-foreground hover:bg-primary/90 h-14 w-full rounded-xl text-lg font-bold shadow-lg transition-all hover:shadow-xl sm:h-16 sm:text-xl"
					>
						{buttonText}
						<ArrowRightIcon class="ml-2" />
					</Button>

					<a
						href={`tel:${templateContext.contact.phone}`}
						class="border-foreground/20 text-foreground hover:bg-foreground/5 inline-flex h-12 w-full items-center justify-center gap-2 rounded-xl border text-base font-semibold transition-colors"
					>
						<PhoneIcon class="size-5" />
						{templateContext.contact.phone}
					</a>

					<p class="text-muted-foreground text-center text-sm">
						Free, no obligation. Takes 30 seconds. No showings needed.
					</p>
				</div>
			</div>
		</div>

		<div class="flex justify-center">
			<a
				href="https://www.bbb.org"
				target="_blank"
				rel="noopener noreferrer"
				class="transition-transform hover:scale-105"
			>
				<img
					src={cloudinaryUrl(templateContext.images.bbbBadge, { width: 500 })}
					alt="BBB Accredited Business A+ Rating"
					class="drop-shadow-lg"
					width="500"
					height="138"
					loading="eager"
					fetchpriority="high"
				/>
			</a>
		</div>
	</div>
</Section>
